import React from 'react';
import '../template-file-css/document-file-template.css';


export const JHC_AdultIntakePacket = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='JHC_AdultIntakePacket' className='file-pdf-document'>

            <div className='file-template'>
                <p className='w-750'>
                    <b> <center> Adult Information/Intake Form   </center> </b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Current Legal Status, Restrictions, or Requirements:</span>
                            <span className='small'>(documentation must be in file)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbCurrentLegalStatus_1' name='cbCurrentLegalStatus_1' className='add-only' value='CurrentLegalStatus_1' /> None </td>
                        <td className='w-250'> <input type='checkbox' id='cbCurrentLegalStatus_2' name='cbCurrentLegalStatus_2' className='add-only' value='CurrentLegalStatus_2' /> Guardianship </td>
                        <td className='w-250'> <input type='checkbox' id='cbCurrentLegalStatus_3' name='cbCurrentLegalStatus_3' className='add-only' value='CurrentLegalStatus_3' /> Power of Attorney </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbCurrentLegalStatus_4' name='cbCurrentLegalStatus_4' className='add-only' value='CurrentLegalStatus_4' /> Conservatorship </td>
                        <td className='w-250'> <input type='checkbox' id='cbCurrentLegalStatus_5' name='cbCurrentLegalStatus_5' className='add-only' value='CurrentLegalStatus_5' /> Mental Health Commitment </td>
                        <td className='w-250'> <input type='checkbox' id='cbCurrentLegalStatus_6' name='cbCurrentLegalStatus_6' className='add-only' value='CurrentLegalStatus_6' /> CINA </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbCurrentLegalStatus_7' name='cbCurrentLegalStatus_7' className='add-only' value='CurrentLegalStatus_7' /> Substance Abuse Commitment </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='checkbox' id='cbCurrentLegalStatus_8' name='cbCurrentLegalStatus_8' className='add-only' value='CurrentLegalStatus_8' /> Other relevant Court Orders requiring treatment or evaluation:  (specify)
                            <input type='text' id='txtCurrentLegalStatus_8Other' name='txtCurrentLegalStatus_8Other' className='add-only w-200 custom-add-only' />

                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Referred by:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbReferredBy_1' name='cbReferredBy_1' className='add-only' value='ReferredBy_1' /> Self  </td>
                        <td className='w-250'> <input type='checkbox' id='cbReferredBy_2' name='cbReferredBy_2' className='add-only' value='ReferredBy_2' /> Hospital  </td>
                        <td className='w-250'> <input type='checkbox' id='cbReferredBy_3' name='cbReferredBy_3' className='add-only' value='ReferredBy_3' /> Family/Friend  </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbReferredBy_4' name='cbReferredBy_4' className='add-only' value='ReferredBy_4' /> School  </td>
                        <td className='w-250'> <input type='checkbox' id='cbReferredBy_5' name='cbReferredBy_5' className='add-only' value='ReferredBy_5' /> Court  </td>
                        <td className='w-250'> <input type='checkbox' id='cbReferredBy_6' name='cbReferredBy_6' className='add-only' value='ReferredBy_6' /> Physician  </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbReferredBy_7' name='cbReferredBy_7' className='add-only' value='ReferredBy_7' /> MHSD  </td>
                        <td className='w-250'> <input type='checkbox' id='cbReferredBy_8' name='cbReferredBy_8' className='add-only' value='ReferredBy_8' /> Probation Officer  </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReferredBy_9' name='cbReferredBy_9' className='add-only' value='ReferredBy_9' /> Other <input type='text' id='txtReferredBy_9Other' name='txtReferredBy_9Other' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Reason for Referral:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbReasonReferral_1' name='cbReasonReferral_1' className='add-only' value='ReasonReferral_1' /> Mental Health </td>
                        <td className='w-500'>
                            <input type='checkbox' id='cbReasonReferral_2' name='cbReasonReferral_2' className='add-only' value='ReasonReferral_2' /> Other: (Please Specify): &nbsp; <input type='text' id='txtReasonReferral_2Other' name='txtReasonReferral_2Other' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Marital Status:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbMaritalStatus_1' name='cbMaritalStatus_1' className='add-only' value='MaritalStatus_1' /> Never Married  </td>
                        <td className='w-250'> <input type='checkbox' id='cbMaritalStatus_2' name='cbMaritalStatus_2' className='add-only' value='MaritalStatus_2' /> Married  </td>
                        <td className='w-250'> <input type='checkbox' id='cbMaritalStatus_3' name='cbMaritalStatus_3' className='add-only' value='MaritalStatus_3' /> Divorced  </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbMaritalStatus_4' name='cbMaritalStatus_4' className='add-only' value='MaritalStatus_4' /> Widowed  </td>
                        <td className='w-250'> <input type='checkbox' id='cbMaritalStatus_5' name='cbMaritalStatus_5' className='add-only' value='MaritalStatus_5' /> Separated  </td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMaritalStatus_6' name='cbMaritalStatus_6' className='add-only' value='MaritalStatus_6' /> Other:
                            <input type='text' id='txtMaritalStatus_6Other' name='txtMaritalStatus_6Other' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>

                        <td className='w-750'><span className='eleHeader'>Ethnicity:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbEthnicity_1' name='cbEthnicity_1' className='add-only' value='Ethnicity_1' /> White/Caucasian  </td>
                        <td className='w-250'> <input type='checkbox' id='cbEthnicity_2' name='cbEthnicity_2' className='add-only' value='Ethnicity_2' /> African America  </td>
                        <td className='w-250'> <input type='checkbox' id='cbEthnicity_3' name='cbEthnicity_3' className='add-only' value='Ethnicity_3' /> Hispanic  </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbEthnicity_4' name='cbEthnicity_4' className='add-only' value='Ethnicity_4' /> American Indian  </td>
                        <td className='w-250'> <input type='checkbox' id='cbEthnicity_5' name='cbEthnicity_5' className='add-only' value='Ethnicity_5' /> Asian/Pacific Islander  </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEthnicity_6' name='cbEthnicity_6' className='add-only' value='Ethnicity_6' /> Other:
                            <input type='text' id='txtEthnicity_6Other' name='txtEthnicity_6Other' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Employment Status:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbEmploymentStatus_1' name='cbEmploymentStatus_1' className='add-only' value='EmploymentStatus_1' /> Full time  </td>
                        <td className='w-250'> <input type='checkbox' id='cbEmploymentStatus_2' name='cbEmploymentStatus_2' className='add-only' value='EmploymentStatus_2' /> Part time  </td>
                        <td className='w-250'> <input type='checkbox' id='cbEmploymentStatus_3' name='cbEmploymentStatus_3' className='add-only' value='EmploymentStatus_3' /> Unemployed/looking for work  </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbEmploymentStatus_4' name='cbEmploymentStatus_4' className='add-only' value='EmploymentStatus_4' /> Student  </td>
                        <td className='w-250'> <input type='checkbox' id='cbEmploymentStatus_5' name='cbEmploymentStatus_5' className='add-only' value='EmploymentStatus_5' /> Retired  </td>
                        <td className='w-250'> <input type='checkbox' id='cbEmploymentStatus_6' name='cbEmploymentStatus_6' className='add-only' value='EmploymentStatus_6' /> Disabled   </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbEmploymentStatus_7' name='cbEmploymentStatus_7' className='add-only' value='EmploymentStatus_7' /> Other
                            <input type='text' id='txtEmploymentStatus_7Other' name='txtEmploymentStatus_7Other' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Veteran Status:</span>
                    <input type='radio' id='rbVeteranStatus_Yes' name='rbVeteranStatus' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbVeteranStatus_No' name='rbVeteranStatus' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbVeteranStatus_NotApply' name='rbVeteranStatus' className='add-only' value='NotApply' /> Does Not Apply  &nbsp;

                </p>
                <p>
                    <span className='eleHeader'>Do you authorize Jackson Hands of Change to call your phone?    </span>
                    <input type='radio' id='rbAuthToCall_Yes' name='rbAuthToCall' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAuthToCall_No' name='rbAuthToCall' className='add-only' value='No' /> No &nbsp;
                </p>
                <p>

                </p>
                <table>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>To leave/send  messages?</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Your Email address:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbToLeavesendMessages_Yes' name='rbToLeavesendMessages' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbToLeavesendMessages_No' name='rbToLeavesendMessages' className='add-only' value='No' /> No &nbsp;
                        </td>
                        <td className='w-375'> <input type='text' id='txtYourEmailAddress' name='txtYourEmailAddress' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Emergency Contact(s):</b>
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'> Relationship to Client:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtName' name='txtName' type='text' className='add-only' /> </td>
                        <td className='w-375'>  <input id='txtRelationshipClient' name='txtRelationshipClient' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <span className='eleHeader'> Street Address:</span> </td>
                        <td className='w-150'> <span className='eleHeader'> City:</span> </td>
                        <td className='w-150'> <span className='eleHeader'> State:</span> </td>
                        <td className='w-100'> <span className='eleHeader'> Zip:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'>  <input id='txtRelationStreetAddress' name='txtRelationStreetAddress' type='text' className='add-only' /> </td>
                        <td className='w-150'>  <input id='txtRelationCity' name='txtRelationCity' type='text' className='add-only' /> </td>
                        <td className='w-150'>  <input id='txtRelationState' name='txtRelationState' type='text' className='add-only' /> </td>
                        <td className='w-100'>  <input id='txtRelationZip' name='txtRelationZip' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Phone:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtRelationPhone' name='txtRelationPhone' type='text' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>FAMILY/HOME INFORMATION</b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> How many dependents do you have? </span>
                            <span className='small'> (Include yourself)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Children:</span> </td>
                        <td className='w-250'> <span className='eleHeader'> Age:</span> </td>
                        <td className='w-250'> <span className='eleHeader'> Living at Home:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input id='txtChildren_1' name='txtChildren_1' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtAge_1' name='txtAge_1' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtLivingHome_1' name='txtLivingHome_1' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input id='txtChildren_2' name='txtChildren_2' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtAge_2' name='txtAge_2' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtLivingHome_2' name='txtLivingHome_2' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input id='txtChildren_3' name='txtChildren_3' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtAge_3' name='txtAge_3' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtLivingHome_3' name='txtLivingHome_3' type='text' className='add-only' /> </td>
                    </tr>

                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> List other people living in the home besides those named above:  </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'> Age:</span> </td>
                        <td className='w-250'> <span className='eleHeader'> Relationship:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input id='txtLivingName_1' name='txtLivingName_1' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtLivingAge_1' name='txtLivingAge_1' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtLivingRelationship_1' name='txtLivingRelationship_1' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input id='txtLivingName_2' name='txtLivingName_2' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtLivingAge_2' name='txtLivingAge_2' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtLivingRelationship_2' name='txtLivingRelationship_2' type='text' className='add-only' /> </td>
                    </tr>

                </table>
                <p className='w-750'>
                    <span className='eleHeader'> Do you currently reside in a:</span>

                    <input type='checkbox' id='cbCurrentlyReside_1' name='cbCurrentlyReside_1' className='add-only' value='CurrentlyReside_1' /> Residential program &nbsp;
                    <input type='checkbox' id='cbCurrentlyReside_2' name='cbCurrentlyReside_2' className='add-only' value='CurrentlyReside_2' /> Correctional Facility &nbsp;
                    <input type='checkbox' id='cbCurrentlyReside_3' name='cbCurrentlyReside_3' className='add-only' value='CurrentlyReside_3' /> Nursing Home

                </p>
                <p className='w-750'>
                    <b>MEDICAL/HEALTH INFORMATION</b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have you received mental health treatment before? </span>
                    <input type='radio' id='rbReceivedMentalHealthTreatment_Yes' name='rbReceivedMentalHealthTreatment' className='add-only' value='Yes' /> Yes  &nbsp;
                    <input type='radio' id='rbReceivedMentalHealthTreatment_No' name='rbReceivedMentalHealthTreatment' className='add-only' value='No' /> No  &nbsp; If so, when and where

                    <textarea id='txtReceivedMentalHealthTreatmentWhenWhere' name='txtReceivedMentalHealthTreatmentWhenWhere' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Do you use: </span>
                    <input type='radio' id='rbYouUse_Drugs' name='rbYouUse' className='add-only' value='Drugs' /> Drugs?  &nbsp;
                    <input type='radio' id='rbYouUse_Tobacco' name='rbYouUse' className='add-only' value='Tobacco' /> Tobacco?  &nbsp;
                    <input type='radio' id='rbYouUse_Alcohol' name='rbYouUse' className='add-only' value='Alcohol' /> Alcohol?  &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have you been treated for alcohol/drug problems before? </span>
                    <input type='radio' id='rbTreatedForProblemsBefore_Yes' name='rbTreatedForProblemsBefore' className='add-only' value='Yes' /> Yes  &nbsp;
                    <input type='radio' id='rbTreatedForProblemsBefore_No' name='rbTreatedForProblemsBefore' className='add-only' value='No' /> No  &nbsp;  If so, when and where

                    <textarea id='txt' name='' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Briefly describe the problem that brings you to Jackson Hands of Change today: </span>

                    <textarea id='txtBrieflyDescribeTheProblem' name='txtBrieflyDescribeTheProblem' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Please check any of the following that you have experienced recently: </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_1' name='cbExperienced_1' className='add-only' value='Experienced_1' /> Depression  </td>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_2' name='cbExperienced_2' className='add-only' value='Experienced_2' /> Anxiety  </td>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_3' name='cbExperienced_3' className='add-only' value='Experienced_3' /> Voices/visions  </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_4' name='cbExperienced_4' className='add-only' value='Experienced_4' /> Suicide  </td>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_5' name='cbExperienced_5' className='add-only' value='Experienced_5' /> Panic attacks  </td>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_6' name='cbExperienced_6' className='add-only' value='Experienced_6' /> Paranoia  </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_7' name='cbExperienced_7' className='add-only' value='Experienced_7' /> Appetite problems  </td>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_8' name='cbExperienced_8' className='add-only' value='Experienced_8' /> Stealing   </td>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_9' name='cbExperienced_9' className='add-only' value='Experienced_9' /> Compulsive behaviors  </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_10' name='cbExperienced_10' className='add-only' value='Experienced_10' /> Weight loss/gain  </td>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_11' name='cbExperienced_11' className='add-only' value='Experienced_11' /> Racing thoughts </td>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_12' name='cbExperienced_12' className='add-only' value='Experienced_12' /> Running away </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_13' name='cbExperienced_13' className='add-only' value='Experienced_13' /> Sleep problems </td>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_14' name='cbExperienced_14' className='add-only' value='Experienced_14' /> Too much energy </td>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_15' name='cbExperienced_15' className='add-only' value='Experienced_15' /> Poor attention </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_16' name='cbExperienced_16' className='add-only' value='Experienced_16' /> Social withdrawal  </td>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_17' name='cbExperienced_17' className='add-only' value='Experienced_17' /> Anger  </td>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_18' name='cbExperienced_18' className='add-only' value='Experienced_18' /> Distractibility  </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_19' name='cbExperienced_19' className='add-only' value='Experienced_19' /> Irritability  </td>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_20' name='cbExperienced_20' className='add-only' value='Experienced_20' /> Low energy  </td>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_21' name='cbExperienced_21' className='add-only' value='Experienced_21' /> Aggression/violence </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_22' name='cbExperienced_22' className='add-only' value='Experienced_22' /> Poor concentration </td>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_23' name='cbExperienced_23' className='add-only' value='Experienced_23' /> Blackouts </td>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_24' name='cbExperienced_24' className='add-only' value='Experienced_24' /> Hyperactivity </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbExperienced_25' name='cbExperienced_25' className='add-only' value='Experienced_25' /> Memory problems </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbExperienced_26' name='cbExperienced_26' className='add-only' value='Experienced_26' /> Other(s)
                            <input type='text' id='txtExperienced_26Other' name='txtExperienced_26Other' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    It is very important for your therapy and medication management at. Jackson Hands of Change, Inc. that we are able to have contact with your primary care provider (PCP).

                    <span className='eleHeader'>Do you give your permission for us to contact your PCP?</span>
                    <input type='radio' id='rbGiveYourPermission_Yes' name='rbGiveYourPermission' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbGiveYourPermission_No' name='rbGiveYourPermission' className='add-only' value='No' /> No &nbsp; (If yes, please complete release of information form)



                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If you decline, please provide specific information for your denial: </span>
                    <textarea id='txtProvideSpecificInformation' name='txtProvideSpecificInformation' className='add-only'></textarea>
                </p>
                <table>


                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Who is your primary doctor/medical provider? </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>City:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtMedicalProviderName' name='txtMedicalProviderName' type='text' className='add-only' /> </td>
                        <td className='w-375'>  <input id='txtMedicalProviderCity' name='txtMedicalProviderCity' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Phone number:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>PCP Fax number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtMedicalProviderPhone' name='txtMedicalProviderPhone' type='text' className='add-only' /> </td>
                        <td className='w-375'>  <input id='txtMedicalProviderFax' name='txtMedicalProviderFax' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Which pharmacy do you use? </span> </td>
                        <td className='w-250'> <span className='eleHeader'>Phone :</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Location OF Pharmacy:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input id='txtPharmacy' name='txtPharmacy' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtPharmacyPhone' name='txtPharmacyPhone' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtPharmacyLocation' name='txtPharmacyLocation' type='text' className='add-only' /> </td>
                    </tr>

                </table>
                <p className='w-750'>
                    <span className='eleHeader'>What medications do you take? </span>
                    <span className='small'>(Include non-prescription, herbal medicines and supplements) </span>
                    <textarea id='txtMedications' name='txtMedications' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Please list any allergies, including medication allergies/sensitivities: </span>
                    <textarea id='txtListAllergies' name='txtListAllergies' className='add-only'></textarea>
                </p>
                <table>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Medicine Dose:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Frequency:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Who prescribes:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input id='txtMedicineDose_1' name='txtMedicineDose_1' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtFrequency_1' name='txtFrequency_1' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtWhoPrescribes_1' name='txtWhoPrescribes_1' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input id='txtMedicineDose_2' name='txtMedicineDose_2' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtFrequency_2' name='txtFrequency_2' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtWhoPrescribes_2' name='txtWhoPrescribes_2' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input id='txtMedicineDose_3' name='txtMedicineDose_3' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtFrequency_3' name='txtFrequency_3' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtWhoPrescribes_3' name='txtWhoPrescribes_3' type='text' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'> Do you have any urgent/critical needs today?</span>
                    <textarea id='txtUrgentCriticalNeeds' name='txtUrgentCriticalNeeds' className='add-only'></textarea>
                </p>



            </div>
        </form >

    )
}







